module.exports = __webpack_public_path__ + "img/Carte-phoenix.8373d588.png";